module.exports = __webpack_public_path__ + "static/media/mail-icon.ac4cd058.svg";